import { defineBlokkliEditAdapter } from '#blokkli/editor/adapter'
import drupalAdapter from '#blokkli/drupal/adapter'

export default defineBlokkliEditAdapter(async (ctx) => {
  const baseAdapter = await drupalAdapter(ctx)
  const runtimeConfig = useRuntimeConfig()

  return {
    ...baseAdapter,

    // Override specific methods from the base adapter.
    buildEditableFrameUrl(e) {
      const url = baseAdapter.buildEditableFrameUrl?.(e)
      if (!url) {
        throw new Error('Failed to build editable frame URL')
      }
      return `${runtimeConfig.public.drupalBackendUrl}${url}`
    },
    formFrameBuilder(e) {
      const result = baseAdapter.formFrameBuilder?.(e)
      if (!result || !result.url) {
        throw new Error('Failed to build form frame')
      }
      return {
        url: `${runtimeConfig.public.drupalBackendUrl}${result.url}`,
      }
    },
  }
})
